export default {
    customerStatus: {
        title: 'Prośba o naprawę w APM Monaco',
        apmSale: 'Serwis posprzedażowy',
        customerName: 'Nazwa klienta',
        shopName: 'Sklep',
        shopPhone: 'Telefon do sklepu',
        shopEmail: 'Adres e-mail',
        created: 'Utworzono',
        productReference: 'Odniesienie',
        repairFee: 'Opłata za naprawę',
        repairReason: 'Powód naprawy',
        clickText: 'Kliknij tutaj, aby śledzić naprawę',
        enjoyText: 'Zapraszamy na zakupy na www.apm.mc',
        tipsText: 'Jesteśmy dostępni 24 godziny na dobę, 7 dni w tygodniu',
        step1Title: 'Krok 1',
        step2Title: 'Krok 2',
        step3Title: 'Krok 3',
        step4Title: 'Krok 4',
        step5Title: 'Krok 5',
        step6Title: 'Krok 6',
        step1Content: 'Wpłata do butiku APM',
        step2Content: 'Przejazd do centrum napraw',
        step3Content: 'Centrum napraw',
        step4Content: 'Przejazd do butiku APM',
        step5Content: 'Produkt gotowy do odbioru',
        step6Content: 'Produkt odebrany',
        orderID: 'Numer zamówienia',
        orderName: 'ID zamówienia',
        trackingNumber: 'Numer śledzenia',
        userName: 'Nazwa',
        userEmail: 'E-mail',
        userPhone: 'Telefon',
        ccStep1Title: 'Krok 1',
        ccStep2Title: 'Krok 2',
        ccStep3Title: 'Krok 3',
        ccStep4Title: 'Krok 4',
        ccStep5Title: 'Krok 5',
        ccStep6Title: 'Krok 6',
        ccStep1Content: 'Oczekiwanie na numer śledzenia',
        ccStep2Content: 'Podano numer śledzenia',
        ccStep3Content: 'Transport do centrum napraw',
        ccStep4Content: 'Centrum napraw',
        ccStep5Content: 'Tranzyt do klienta',
        ccStep6Content: 'Dostarczono',
    },
};